module.exports = __webpack_public_path__ + "img/wp-existing-habit-card12.9ed3f062.jpg";